/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Button, rem, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { RiArrowLeftLine } from '@remixicon/react';

import type { PropsWithChildren } from '@fai/util/types';

// If mobile show arrow icon only
export default function PillBackButton({
  onClick,
  children,
}: PropsWithChildren<{ onClick: VoidFunction }>) {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);

  return (
    <Button
      variant="pill"
      size="sm"
      w="fit-content"
      styles={{ section: { marginRight: isMobile ? 0 : rem(4) } }}
      leftSection={<RiArrowLeftLine color={theme.pf.color.fg.neutral.strong} size={16} />}
      onClick={onClick}
    >
      {isMobile ? null : children}
    </Button>
  );
}

PillBackButton.displayName = 'PillBackButton';
